import React, { Component, useState } from 'react';
import './imagemanagement.css';
import { showNotification } from '../../StatusNotification';
import { showConfirmation } from '../../ConfirmationModal';

export class ImageDeletion extends Component {
    static displayName = ImageDeletion.name;

    constructor(props) {
        super(props);
        this.state = {
            images: [],
            toDelete: []
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    async loadImages() {
        const response = await fetch('ImageUpload/RetrieveAll', {
            method: 'POST'
        });

        const data = await response.json();

        this.setState({
            images: data
        });
    }

    handleDeleteCheckboxChange = (e) => {
        const id = e.target.dataset.id;
        const isChecked = e.target.checked;

        this.setState(prevState => {
            let newToDelete = [...prevState.toDelete];

            if (isChecked) {
                // Add ID to array if not already present
                if (!newToDelete.includes(id)) {
                    newToDelete.push(id);
                }
            } else {
                // Remove ID from array
                const index = newToDelete.indexOf(id);
                if (index > -1) {
                    newToDelete.splice(index, 1);
                }
            }

            return { toDelete: newToDelete };
        });
    }

    //async deleteImage(e) {
    //    if (window.confirm("Are you sure you want to delete this image?")) {
    //        await fetch("ImageUpload/DeleteImage", {
    //            method: 'POST',
    //            headers: {
    //                'Content-Type': 'application/json'
    //            },
    //            body: JSON.stringify({
    //                Id: this.state.editImageId,
    //                ImageDescription: this.state.editImageDescription
    //            })
    //        });
    //        this.editToggle(this);
    //        this.loadImages();
    //    }
    //}

    deleteItems = async (e) => {
        e.preventDefault();

        if (this.state.toDelete.length === 0) {
            showNotification("Please select items to delete", "error");
            return;
        }

        let confirmDelete = await showConfirmation("Are you sure you want to delete the selected items?");
        if (!confirmDelete) {
            return;
        }

        let allSuccess = true;
        let errorMessages = [];

        for (let i = 0; i < this.state.toDelete.length; i++) {

            try {
                const response = await fetch("ImageUpload/DeleteImage", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        Id: parseInt(this.state.toDelete[i]),
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

            } catch (error) {
                allSuccess = false;
                errorMessages.push(`Image ${this.state.toDelete[i]}: ${error.message}`);
            }
        }

        if (allSuccess) {
            // Clear the selection and refresh the data
            this.setState({ toDelete: [] });
            this.getComponentData();
            showNotification("All images deleted successfully", "success");
        } else {
            showNotification("Some deletions failed:\n" + errorMessages.join("\n"), "error");
            // Still refresh to show current state
            this.setState({ toDelete: [] });
            this.getComponentData();
        }

        this.loadImages();
    }

    render() {
        let images = this.state.images;
        let table = null;

        if (images.length > 0) {
            table = (
                <table>
                    <thead>
                        <tr>
                            <th>Select</th>
                            <th>Url</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {images.map((image, i) => {
                            return (
                                <tr key={image.id || i}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            data-id={image.id}
                                            checked={this.state.toDelete.includes(image.id.toString())}
                                            onChange={this.handleDeleteCheckboxChange}
                                        />
                                    </td>
                                    <td><img style={{ maxWidth: '450px', maxHeight: '100px' }} src={"images/" + image.imageUrl} alt={image.imageDescription || "Image"} /></td>
                                    <td>{image.imageDescription}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            );
        }

        return (
            <div className='image-management'>
                <div className='page-title'>
                    <h1>Image Deletion</h1>
                </div>

                <div className='table-container'>
                    <button onClick={this.deleteItems} className='form-management-button'>Delete Selected</button>
                    {table}
                </div>
            </div>
        );
    }

    async getComponentData() {
        await this.loadImages();
    }
}